import types from '@/actions/types';
import useR2RChat from '@/composables/useR2RChat';
import useSequence from '@/composables/useSequence';
import Base from '@/actions/base';
import useAnalytics from '@/composables/useAnalytics';

export default class R2RChat extends Base {
  constructor(params) {
    super(params, types.R2R_CHAT);

    this.hideAvatar = params.hideAvatar;
    this.version = params.version;
    this.targetFrame = params.targetFrame;
    this.unavailableNext = params.unavailableNext;
  }

  execute() {
    const { executeRobotChat } = useR2RChat();
    const { currentSeq } = useSequence();
    const { trackAction } = useAnalytics();
    trackAction(this);

    return new Promise((resolve) => {
      executeRobotChat({
        version: this.version,
        targetFrame: this.targetFrame,
        unavailableNext: this.unavailableNext,
        elementId: currentSeq.value.id,
      });
      this.resolve = resolve;
    });
  }

  stop() {
    if (this.resolve) {
      this.resolve();
    }
  }

  pause() {
    const { stopChat } = useR2RChat();
    stopChat();
    this.resolve();
  }

  resume() {
    this.resolve();
  }
}
